<div class="registration-entry-list">
  <button
    mat-stroked-button
    color="primary"
    type="button"
    class="ui-outlined registration-entry-list__add"
    *ngIf="editor.showAddButton"
    [disabled]="addDisabled"
    (click)="editor.startAdd()"
  >
    <mat-icon>add</mat-icon>
    <span>{{ addLabel }}</span>
  </button>

  <ng-container *ngFor="let row of rows.controls; let i = index">
    <ng-container
      *ngIf="editor.isAddingRow(row)"
      [ngTemplateOutlet]="editorTemplate"
      [ngTemplateOutletContext]="{ $implicit: row, index: i }"
    >
    </ng-container>
  </ng-container>

  <ng-container *ngFor="let row of rows.controls; let i = index">
    <ng-container
      *ngIf="editor.isEditingExistingRow(row)"
      [ngTemplateOutlet]="editorTemplate"
      [ngTemplateOutletContext]="{ $implicit: row, index: i }"
    >
    </ng-container>

    <ng-container
      *ngIf="editor.isRowCollapsed(row)"
      [ngTemplateOutlet]="cardTemplate"
      [ngTemplateOutletContext]="{ $implicit: row, index: i }"
    >
    </ng-container>
  </ng-container>
</div>
